import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import * as actions from './actions';
import * as state from './state';
import { Actions, ofType } from '@ngrx/effects';
import { map, take, tap } from 'rxjs/operators';
import { AppStoreService, AppState } from '@stop-counter/store';
import { PostType, ProductType } from '@apps/api-interfaces';

@Injectable()
export class PostsStoreService extends AppStoreService {
  private invoicesState = createFeatureSelector<state.PostState>('posts');

  private selectors = state.invoicesAdapter.getSelectors(this.invoicesState);

  private isLoading = createSelector(
    this.invoicesState,
    state.selectIsLoading
  );
  private error = createSelector(
    this.invoicesState,
    state.selectError
  );

  constructor(protected store: Store<AppState>, private action$: Actions) {
    super();
  }

  async dispatchLoad(type?: PostType) {
    this.dispatchAction(new actions.LoadAction(type));
    return await this.action$
      .pipe(
        // ERROR tez konczy oczekiwanie: czekanie wylacznie na LOAD_SUCCESS
        // po bledzie HTTP zostawia promise na zawsze - resolver trasy wisi,
        // a SSR renderuje pusty router-outlet ze statusem 200.
        ofType(actions.Actions.LOAD_SUCCESS, actions.Actions.ERROR),
        map((action: any) =>
          action.type === actions.Actions.LOAD_SUCCESS ? action.payload : []
        ),
        take(1)
      )
      .toPromise();
  }

  async dispatchLoadSingle(slug: string) {
    this.dispatchAction(new actions.LoadSingleAction(slug));
    return await this.action$
      .pipe(
        // ERROR tez konczy oczekiwanie: czekanie wylacznie na LOAD_SUCCESS
        // po bledzie HTTP zostawia promise na zawsze - resolver trasy wisi,
        // a SSR renderuje pusty router-outlet ze statusem 200.
        ofType(actions.Actions.LOAD_SUCCESS, actions.Actions.ERROR),
        map((action: any) =>
          action.type === actions.Actions.LOAD_SUCCESS ? action.payload : []
        ),
        take(1)
      )
      .toPromise();
  }

  getAll() {
    return this.store.select(this.selectors.selectAll);
  }

  getItems(type: PostType, product?: ProductType, home?: boolean) {
    return this.store.select(this.selectors.selectAll).pipe(
      map(e => {
        return e
          .filter(a => a.type === type)
          .filter(a => !product || a.product.includes(product))
          .filter(a => home === undefined || a.promo === home);
      })
    );
  }

  getItemsByCategory(slug: string, type: PostType, product?: ProductType) {
    return this.store.select(this.selectors.selectAll).pipe(
      map(e => {
        return e
          .filter(a => a.type === type)
          .filter(a => !product || a.product.includes(product))
          .filter(
            a => a.categoryNames && !!a.categoryNames.find(c => c.slug === slug)
          );
      })
    );
  }

  getSingle(slug: string, product?: ProductType, type?: PostType) {
    return this.store.select(this.selectors.selectAll).pipe(
      map(e => {
        return e.find(
          a =>
            a.slug === slug &&
            (!product ||
              (a.product.includes(product) && (!type || a.type === type)))
        );
      })
    );
  }

  getIsLoading() {
    return this.store.select(this.isLoading);
  }

  getError() {
    return this.store.select(this.error);
  }
}
